export const DeliveryType = {
  None : 0,
  Analog : 1, // 0b_0001
  Digital : 2, // 0b_0010
  Hybrid : 3, // 0b_0011
  Auto : 4
}
